import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import {
  createSubCategory,
  updateSubCategory,
  deleteSubCategory,
  getSubCategories,
} from "data/server_apis/commodityService";
const subCategoryAdapter = createEntityAdapter({
  selectId: (subCategory) => subCategory.id,
});
export const createSubCategoryThunk = createAsyncThunk(
  "product_sub_category/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createSubCategory(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getSubCategoriesThunk = createAsyncThunk(
  "product_sub_category/getCategories",
  async (id, { rejectWithValue }) => {
    try {
      return (await getSubCategories(id)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteSubCategoriesThunk = createAsyncThunk(
  "product_sub_category/deleteCategories",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteSubCategory(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateSubCategoryThunk = createAsyncThunk(
  "product_sub_category/updateSubCategory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateSubCategory(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const subCategorySlice = createSlice({
  name: "product_sub_category",
  initialState: subCategoryAdapter.getInitialState({
    loading: {},
    error: {},
    errorMessage: {},
    success: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSubCategoryThunk.pending, (state, action) => {
        state.loading = { create: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(createSubCategoryThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { create: true };
        state.success = {};
        state.errorMessage = { create: action.payload?.message };
      })
      .addCase(createSubCategoryThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { create: true };
        state.errorMessage = {};
        subCategoryAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(getSubCategoriesThunk.pending, (state, action) => {
        state.loading = { list: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(getSubCategoriesThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { list: true };
        state.success = {};
        state.errorMessage = { list: action.payload?.message };
      })
      .addCase(getSubCategoriesThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { list: true };
        state.errorMessage = {};
        subCategoryAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(deleteSubCategoriesThunk.pending, (state, action) => {
        state.loading = { delete: action.meta.arg };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(deleteSubCategoriesThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { delete: true };
        state.success = {};
        state.errorMessage = { delete: action.payload?.message };
      })
      .addCase(deleteSubCategoriesThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { delete: true };
        state.errorMessage = {};
        subCategoryAdapter.removeOne(state, action.meta.arg);
      });

    builder
      .addCase(updateSubCategoryThunk.pending, (state, action) => {
        state.loading = { update: action.meta.arg.id };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(updateSubCategoryThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { update: action.meta.arg.id };
        state.success = {};
        state.errorMessage = { update: { id: action.payload?.message } };
      })
      .addCase(updateSubCategoryThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { update: action.meta.arg.id };
        state.errorMessage = {};
        subCategoryAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });
  },
});
export const subCategorySelector = subCategoryAdapter.getSelectors(
  (state) => state.subCategory
);

export const {} = subCategorySlice.actions;

export default subCategorySlice.reducer;
